export default theme => ({

  title: {
    paddingTop: '30vh'
  }

});




// WEBPACK FOOTER //
// ./src/styles/components/Message.js